import React from 'react';
import { Helmet } from 'react-helmet';

function SEO({ title, description }) {
  const siteTitle = 'CWC Student Program';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Get Paid to Do Real Cybersecurity Work`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description || 'Get paid to do real cybersecurity work before you graduate. $140 per assessment. CISSP expert feedback. Portfolio-grade deliverables. Apply in 5 minutes.'} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description || 'Get paid to do real cybersecurity work before you graduate. $140 per assessment with CISSP expert feedback.'} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://students.cyberwisecorp.com" />
      <meta property="og:image" content="https://cyberwisecorp.com/images/cwc-logo-full.png" />
      <meta property="og:image:width" content="512" />
      <meta property="og:image:height" content="512" />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:image" content="https://cyberwisecorp.com/images/cwc-logo-full.png" />
    </Helmet>
  );
}

export default SEO;
